import { Route, Routes } from "react-router-dom";
import ResourceNotFound from "../../Common/ResourceNotFound";
import SettingsCompanyInfo from "./SettingsCompanyInfo";
import SettingsReport from "./SettingsReport";
import SettingOpeningBalanceNew from "./SettingOpeningBalanceNew";
import SettingsEmail from "./SettingsEmail";
import SettingsTemplates from "./SettingsTemplates";
import { Card } from "antd";
import SettingSecCustomization from "./SettingSecCustomization";
import SettingDefaultLedger from "./SettingDefaultLedger";
import TermsAndConditions from "./TermsAndConditions";
import TdsList from "../TcsTds/Tds/TdsList";
import SettingItems from "./SettingItems";
import SettingCurrency from "./Currency/CurrencyTable";
import LockMonth from "./LockMonth";
import { useUser } from "../../../Context/UserContext";
import { IAccessSettings } from "../../../Types";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../Users/UserSecurityFind";
import { useClient } from "../../Context/ClientContext";
import { SettingsSections } from "../../Services/SettingService";
import { IPermissionActionType } from "../Users/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";
// import SettingsNewDashboard from "./SettingsNewDashboard";

const SettingNestedRoute = () => {
  const { currentClient } = useClient();
  const { accessSettings, clientSpecificRole } = useUser();
  const useAccessSettingsData: IAccessSettings = accessSettings();

  return (
    <Card
      size="small"
      className="TableCard"
      style={{
        marginTop: "6px",
        padding: "15px 0px 0px 0px",
        boxShadow: "0px 0px 10px 0px #96A1C84D",
      }}
    >
      <Routes>
        <Route
          path="/companyInfo"
          element={
            findUserPremission(
              [
                "Setting.Company.Info.View",
                "Setting.Company.Details.View",
                "Setting.Company.PaymentTerm.View",
                "Setting.Company.GST.View",
              ],
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              // findUserSettingAccessSecurity(
              //   useAccessSettingsData,
              //   Setting_Type.CompanyInfo
              // ) ?
              <SettingsCompanyInfo />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/vouchers"
          element={
            findUserPremission(
              [
                "Setting.Voucher.Sales.View",
                "Setting.Voucher.ProformaInvoice.View",
                "Setting.Voucher.CreditNote.View",
                "Setting.Voucher.Receipt.View",
                "Setting.Voucher.Estimate.View",
                "Setting.Voucher.SalesOrder.View",

                "Setting.Voucher.Bill.View",
                "Setting.Voucher.DebitNote.View",
                "Setting.Voucher.PaymentOut.View",
                "Setting.Voucher.PurchaseOrder.View",

                "Setting.Voucher.Expenses.View",
                "Setting.Voucher.Income.View",

                "Setting.Voucher.Contra.View",
                "Setting.Voucher.Journal.View",
                "Setting.Voucher.FixedAsset.View",
              ],
              clientSpecificRole(),
              currentClient?.id!,
              [
                SettingsSections.Invoice,
                SettingsSections.PInvoice,
                SettingsSections.CrNote,
                SettingsSections.Receipt,
                SettingsSections.Quotation,
                SettingsSections.SOrder,

                // Purchase
                SettingsSections.PurInvoice,
                SettingsSections.DrNote,
                SettingsSections.Payment,
                SettingsSections.POrder,

                // expenses & income
                SettingsSections.Expenses,
                SettingsSections.Income,

                // Journal
                SettingsSections.Journal,
                // Contra
                SettingsSections.Contra,
                // Asset
                SettingsSections.Asset,
              ],
              {
                actionType: IPermissionActionType.View,
                dataType: [ITypeIIsClientSpecificRoleDataType.Setting],
              }
            ) ? (
              <SettingSecCustomization />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/items"
          element={
            findUserOnlyOnePremission(
              "Setting.Item.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <SettingItems />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        {/* <Route path="/paymentTerm" element={<SettingPaymentTerm />} /> */}
        {/* <Route path="/gst" element={<SettingsGst />} /> */}
        <Route
          path="/report"
          element={
            // findUserPremission(
            //   ["Setting.Item.View"],
            //   clientSpecificRole(),
            //   currentClient?.id!
            // ) ? (
            <SettingsReport />
            // ) : (
            //   <ResourceNotFound pageHeight="100%" />
            // )
          }
        />
        <Route
          path="/openingBalance"
          element={
            findUserOnlyOnePremission(
              "Setting.OpeningBalance.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <SettingOpeningBalanceNew />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/email"
          element={
            findUserOnlyOnePremission(
              "Setting.Email.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <SettingsEmail />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/templates"
          element={
            findUserOnlyOnePremission(
              "Setting.Templates.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <SettingsTemplates />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        {/* <Route path="/advSetting" element={<SettingsAdvance />} /> */}
        <Route
          path="/termsandConditions"
          element={
            findUserPremission(
              [
                "Setting.TC.Sales.View",
                "Setting.TC.ProformaInvoice.View",
                "Setting.TC.CreditNote.View",
                "Setting.TC.Receipt.View",
                "Setting.TC.Estimate.View",
                "Setting.TC.SalesOrder.View",
                "Setting.TC.Bill.View",
                "Setting.TC.DebitNote.View",
                "Setting.TC.PaymentOut.View",
                "Setting.TC.PurchaseOrder.View",
                "Setting.TC.Expenses.View",
                "Setting.TC.Income.View",
                "Setting.TC.Contra.View",
                "Setting.TC.Journal.View",
                "Setting.TC.FixedAsset.View",
              ],
              clientSpecificRole(),
              currentClient?.id!,
              [
                SettingsSections.Invoice,
                SettingsSections.PInvoice,
                SettingsSections.CrNote,
                SettingsSections.Receipt,
                SettingsSections.Quotation,
                SettingsSections.SOrder,

                // Purchase
                SettingsSections.PurInvoice,
                SettingsSections.DrNote,
                SettingsSections.Payment,
                SettingsSections.POrder,

                // expenses & income
                SettingsSections.Expenses,
                SettingsSections.Income,

                // Journal
                SettingsSections.Journal,
                // Contra
                SettingsSections.Contra,
                // Asset
                SettingsSections.Asset,
              ],
              {
                actionType: IPermissionActionType.View,
                dataType: [ITypeIIsClientSpecificRoleDataType.TandC],
              }
            ) ? (
              <TermsAndConditions />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/tds"
          element={
            findUserOnlyOnePremission(
              "Setting.TDS.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <TdsList Role="ADMIN" />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />

        <Route
          path="/defaultLedger"
          element={
            findUserOnlyOnePremission(
              "Setting.DefaultLedger.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <SettingDefaultLedger />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/currencies"
          element={
            findUserOnlyOnePremission(
              "Setting.Currencies.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <SettingCurrency />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route path="/lockmonth" element={<LockMonth />} />
        {/* <Route path="/newDashboard" element={<SettingsNewDashboard />} /> */}
        <Route path="*" element={<ResourceNotFound pageHeight="100%" />} />
      </Routes>
    </Card>
  );
};

export default SettingNestedRoute;
